import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <g id="B" transform="translate(30.000000, 20.000000)">
        <path
          d="M0.31179 44V0.363635H8.21662V37.3736H27.4354V44H0.31179Z"
          fill="currentColor"
        />
        </g>
      </g>
    </g>
  </svg>
);

export default IconLogo;
